import { useLoginVerify } from './useLoginVerify';

// A portal identity is a HubSpot user (an account seat / employee) — as opposed
// to a plain membership contact — when loginVerify returns a userId. The backend
// sets userId only from the membership cookie's isHubSpotUser flag, so its
// presence is the canonical "is a HubSpot user" signal on the frontend.
export function useIsHubSpotUser() {
  const {
    data
  } = useLoginVerify();
  return (data === null || data === void 0 ? void 0 : data.userId) != null;
}